import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Params, Router } from '@angular/router';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ZipCodes } from 'src/app/features-common/constants/ZipCodes';
import { Retailer } from 'src/app/features-common/models/retailer.model';
import Swal from 'sweetalert2';
import { RetailerService } from '../retailer.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-manage-retailer',
  templateUrl: './manage-retailer.component.html',
  styleUrls: ['./manage-retailer.component.scss']
})
export class ManageRetailerComponent extends FeaturesBaseComponent implements OnInit {
  retailerId;
  currentRoute

  constructor(private retailerService: RetailerService, private router: Router, private activeRoute:ActivatedRoute) {
    super();
    //this.retailerId = this.router.getCurrentNavigation().extras.state;
    this.retailerId = this.activeRoute.snapshot.params.retailerId;
    //console.log("In ManageRetailerComponent " + this.retailerId)
  }

  ngOnInit(): void {

    super.ngOnInit();
    this.router.navigate([`/features/retailers/manageretailer/${this.retailerId}/updateretailer/${this.retailerId}`])
  }
}
